import React from 'react';

// Define the possible sizes
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProperties extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    /** Optional className to ADD to the selected size/base styles */
    className?: string;
    /** Specifies the button size. Defaults to 'md'. */
    size?: ButtonSize;
}

// Base styles (common to all sizes) - removed padding and text-size
const baseButtonStyles = `
    bg-blue-700 text-white rounded-md
    hover:bg-blue-600 focus:outline-none focus:ring-2
    focus:ring-blue-500 focus:ring-offset-2
    hover:cursor-pointer inline-flex items-center justify-center /* Added flex alignment */
    disabled:opacity-50 disabled:cursor-not-allowed
    transition-colors duration-150 ease-in-out /* Added transition */
`;

// Size-specific styles (padding and font-size)
const sizeClasses: Record<ButtonSize, string> = {
    sm: 'px-3 py-1 text-sm',      // Smaller padding, smaller text
    md: 'px-4 py-2 text-base',    // Original default padding and text size
    lg: 'px-6 py-3 text-lg',      // Larger padding, larger text (example)
};

const SamButton: React.FC<ButtonProperties> = ({
                                                   children,
                                                   className = '',
                                                   size = 'md', // Default size is 'md'
                                                   ...properties
                                               }) => {

    // Otherwise, combine base, size-specific, and additional classes
    const sizeSpecificStyles = sizeClasses[size] || sizeClasses.md; // Fallback to 'md' just in case
    const combinedClassName = `${baseButtonStyles} ${sizeSpecificStyles} ${className}`.trim(); // Use trim() to clean up potential extra spaces


    return (
        <button
            type="button" // Default to type="button" unless specified otherwise
            {...properties}
            className={combinedClassName}
        >
            {children}
        </button>
    );
};

export default SamButton;